module.exports = __webpack_public_path__ + "img/banner.9206cc9a.png";